import React, { useEffect, useState } from "react";
import { Paper, Tabs, Tooltip, Typography, Tab } from "@mui/material";
import { withStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import MaterialTable from "@material-table/core";
import moment from "moment";
import InfoIcon from "@mui/icons-material/Info";

import { useStylesLayout } from "../styles/Layout";
import { getUsersWithAccess, getUsersWithAccessCustom } from "../store/ducks/duckHelp";
import { downloadUsersInfo, getAuditOfCustomRoute } from "../store/ducks/duckAudit";
import getBrowserName from "../utils/getBrowserName";
import { isJson } from "../utils/jsonUtilities";
import NavBar from "../components/Navbar";
import { getAuditOfLayout, getUsers, getUsersCustom } from "../store/ducks/duckAudit";
import { BorderLinearProgress } from "../components/LoadingComponent";

const fileDownload = require("js-file-download");

const TabStyled = withStyles(() => ({
  root: {
    minWidth: 300,
    width: 300,
  },
}))(Tab);

const Audit = () => {
  const { loading } = useSelector((state) => state.audit);

  const classes = useStylesLayout();
  const { id } = useParams(); //Audit/:id

  const dispatch = useDispatch();

  const [tab, setTab] = useState(0);

  useEffect(() => {
    if (isNaN(id)) {
      //recibe la ruta y trae de la api una lista con los usuarios
      dispatch(getUsersCustom(id));
      //trae los usuarios agrupados por el id
      dispatch(getUsersWithAccessCustom(id));
    } else {
      dispatch(getUsers(id));
      dispatch(getUsersWithAccess(id));
    }
  }, [dispatch, id]);

  const { layoutIsPublic: isPublic, isLoading } = useSelector((state) => state.help);

  const data = useSelector((state) => {
    let data = [...state.help.data];

    let dataModified = data.map(({ group, users }) => {
      return {
        users: users.map((x) => ({ ...x, group })),
      };
    });

    dataModified = dataModified.map((x) => x.users).flat();

    return dataModified;
  });

  const columns = [
    {
      title: "Id",
      field: "id",
      hiddenByColumnsButton: true,
    },
    {
      title: "Category",
      field: "category",
      align: "justify",
      editable: "never",
    },
    {
      field: "action",
      title: "Action",
      align: "justify",
      editable: "never",
    },
    {
      field: "user",
      title: "User",
      align: "justify",
      editable: "never",
    },
    {
      field: "date",
      title: "Date",
      align: "justify",
      editable: "never",
      filtering: false,
      // eslint-disable-next-line react/prop-types
      render: ({ date }) => {
        //let dateFormated = moment.utc(date).local();
        let dateFormated = moment(date);

        return (
          <Typography key={`Date-${id}`} color="textPrimary" component={"div"}>
            {dateFormated.format("DD/MM/YYYY")}
            <Typography color="textSecondary">{dateFormated.format("hh:mm A")}</Typography>
          </Typography>
        );
      },
    },
    {
      field: "resource",
      title: "Resource",
      align: "justify",
      editable: "never",
      cellStyle: {
        width: 150,
        maxWidth: 150,
      },
      headerStyle: {
        width: 150,
        maxWidth: 150,
      },
      // eslint-disable-next-line react/prop-types
      render: ({ resource, id, resourceId }) => {
        return (
          <Tooltip key={`Tooltip-resource-${id}`} title={resource ?? ""}>
            <Typography noWrap color="textSecondary">
              {resource}
              {resourceId ? `: ${resourceId}` : ""}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "browser",
      title: "Browser",
      align: "justify",
      editable: "never",
      render: ({ browser, id }) => {
        let name = getBrowserName(browser);

        if (!name) return null;

        return (
          <Tooltip key={`Tooltip-resource-${id}`} title={name ?? ""}>
            <Typography noWrap color="textSecondary">
              {name}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "ipClient",
      title: "IP",
      align: "justify",
      editable: "never",
    },
    {
      field: "pathMenu",
      title: "Path",
      align: "justify",
      editable: "never",
    },
    {
      field: "details",
      title: "Details",
      align: "justify",
      editable: "never",
      render: ({ details, id }) => {
        let detailsC = details;

        if (isJson(details)) {
          let detailsO = JSON.parse(details);

          detailsC = (
            <ul key={`tooltip-custom-list-${id}`}>
              {Object.entries(detailsO).map(([key, value]) => (
                <li key={`Details-Property-${id}-${key}`}>{`${key}: ${value}`}</li>
              ))}
            </ul>
          );
        }

        if (details) {
          return (
            <Tooltip key={`Tooltip-details-${id}`} title={detailsC ?? ""}>
              <InfoIcon />
            </Tooltip>
          );
        }
      },
    },
  ];

  const options = {
    actionsColumnIndex: -1,
    pageSize: 7,
    pageSizeOptions: [],
    padding: "dense",
  };
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <>
      <NavBar />
      <Paper className={classes.administrationPaper}>
        {loading && <BorderLinearProgress />}
        <Tabs
          aria-label="TabsGroups"
          indicatorColor="primary"
          textColor="primary"
          value={tab}
          variant="scrollable"
          onChange={handleChange}
        >
          <TabStyled key={"Tab-Details"} label={"Details"} value={0} />
          {!isPublic && <TabStyled key={"Tab-Groups"} label={"Users and Groups"} value={1} />}
        </Tabs>
        <Typography
          key={"div-container-tabPanel-Groups"}
          aria-labelledby={"simple-tab-Groups"}
          component={"span"}
          hidden={tab !== 1}
          role="tabpanel"
        >
          {!isPublic && (
            <MaterialTable
              columns={[
                {
                  field: "networkUser",
                  title: "User",
                },
                {
                  field: "emailAddress",
                  title: "Email",
                },
                {
                  field: "group",
                  title: "Group",
                },
                {
                  title: "Name",
                  field: "displayName",
                },
              ]}
              data={data}
              isLoading={isLoading}
              localization={{
                toolbar: {
                  exportCSVName: "Export Excel",
                },
              }}
              options={{
                ...options,
                pageSize: 10,
                exportButton: true,
                exportAllData: true,
                exportCsv: (column, data) => {
                  dispatch(downloadUsersInfo(data)).then((response) => {
                    fileDownload(response.payload.data, "Users.xlsx");
                  });
                },
              }}
              title={"Users"}
            />
          )}
        </Typography>

        <Typography
          key={"div-container-tabPanel-Details"}
          aria-labelledby={"simple-tab-Details"}
          component={"span"}
          hidden={tab !== 0}
          role="tabpanel"
        >
          <MaterialTable
            columns={columns}
            data={(query) =>
              new Promise((resolve, _reject) => {
                if (!isNaN(id)) {
                  dispatch(getAuditOfLayout(id, query)).then((response) => {
                    let { data, page, totalCount } = response.payload.data;

                    resolve({
                      data, // your data array
                      page: page, // current page number
                      totalCount, // total row number
                    });
                  });
                } else {
                  dispatch(getAuditOfCustomRoute(id, query)).then((response) => {
                    let { data, page, totalCount } = response.payload.data;

                    resolve({
                      data, // your data array
                      page: page, // current page number
                      totalCount, // total row number
                    });
                  });
                }
              })
            }
            options={{ ...options, debounceInterval: 500, sorting: false, columnsButton: true }}
            title={"Audit"}
          />
        </Typography>
      </Paper>
    </>
  );
};

export default Audit;
